export default __webpack_public_path__ + "static/web-button-cc368382d6e94d51ddb73445dc713867.svg";